import React from 'react';
import {ScrollView, Text} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';

import DarkPinInput from './DarkPinInput';
import LightPinInput from './LightPinInput';

storiesOf('base', module).add('PinInput', () => {
  return (
    <ScrollView>
      <Spacing size={20}>
        <FlexView>
          <Heading level={1}>PinInput</Heading>
          <Spacer size={16} />
          <Text>
            The <Code>PinInput</Code> component is used to handle a pin code
            animation. There are two types of PinInput:{' '}
            <Code>CreatePinInput</Code> and <Code>EnterPinInput</Code>.
          </Text>
          <Spacer size={16} />
          <Text>
            To each type of <Code>PinInput</Code> we can pass <Code>theme</Code>{' '}
            prop of 'dark' or 'light' value. We can determine{' '}
            <Code>textVariant</Code> prop.
          </Text>
          <LightPinInput />
          <DarkPinInput />
        </FlexView>
      </Spacing>
    </ScrollView>
  );
});
